













import { Component, Prop, Vue } from 'vue-property-decorator'
import { CompApi } from '@/config/components/type'

@Component
export default class ApiTable extends Vue {
  @Prop() api!: CompApi
}
